import React from 'react';
import PropTypes from 'prop-types';
import { DataPairLayout } from '../DataPairLayout';
import { CardTitle, CardContent } from '../Typography';

export const DatumPairCard = props => {
  let children = React.Children.toArray(props.children);
  let title = props.title ? props.title : children[0];
  let content = props.title ? props.children : children[1];

  return (
    <DataPairLayout title={<CardTitle>{title}</CardTitle>}>
      {<CardContent>{content}</CardContent>}
    </DataPairLayout>
  );
};

DatumPairCard.propTypes = {
  /** Node that will be shown as the Datum descriptor*/
  title: PropTypes.node,
  /** Children node to be shown as the Datum value */
  children: PropTypes.node.isRequired
};
